import React from 'react';
import './Skeleton.css';

export const Skeleton = ({ width = '100%', height = '1rem', radius, className = '' }) => (
    <span
        className={`skeleton ${className}`.trim()}
        style={{ width, height, borderRadius: radius }}
        aria-hidden="true"
    />
);

/** Page placeholder instead of a blank screen. `variant`: rows | cards | form | details */
export const PageSkeleton = ({ variant = 'rows', count = 5, label = 'Загрузка...' }) => {
    const items = Array.from({ length: count }, (_, index) => index);

    return (
        <div className={`skeleton-page skeleton-page-${variant}`} role="status" aria-busy="true">
            <span className="sr-only">{label}</span>
            {variant === 'cards' && items.map((item) => (
                <div key={item} className="skeleton-card">
                    <Skeleton width="55%" height="1.1rem" />
                    <Skeleton width="85%" />
                    <Skeleton width="40%" />
                </div>
            ))}
            {variant === 'rows' && items.map((item) => (
                <div key={item} className="skeleton-row">
                    <Skeleton width="44px" height="44px" radius="var(--radius-sm)" />
                    <div className="skeleton-row-lines">
                        <Skeleton width="50%" />
                        <Skeleton width="75%" height="0.8rem" />
                    </div>
                </div>
            ))}
            {variant === 'form' && (
                <div className="skeleton-card">
                    {items.map((item) => (
                        <div key={item} className="skeleton-field">
                            <Skeleton width="30%" height="0.8rem" />
                            <Skeleton height="var(--control-height)" radius="var(--radius-sm)" />
                        </div>
                    ))}
                </div>
            )}
            {variant === 'details' && (
                <>
                    <div className="skeleton-card">
                        <Skeleton width="40%" height="1.4rem" />
                        <Skeleton width="70%" />
                        <Skeleton width="55%" />
                    </div>
                    <div className="skeleton-card">
                        <Skeleton width="30%" height="1.1rem" />
                        {items.map((item) => <Skeleton key={item} width={`${90 - item * 8}%`} />)}
                    </div>
                </>
            )}
        </div>
    );
};

export default Skeleton;
